import {
  Button,
  ClickAwayListener,
  styled,
  Tooltip,
  tooltipClasses,
  TooltipProps,
} from "@mui/material";
import { useState } from "react";
import { ShipmentResponse } from "../../app/models/responseModels/shipmentResponse";

const BootstrapTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip
    {...props}
    arrow
    classes={{ popper: className }}
    sx={{ fontSize: 40 }}
  />
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: theme.palette.warning.light,
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.warning.light,
    fontSize: theme.typography.pxToRem(14),
  },
}));

type RecipientDetailsTooltipProps = {
  shipment: ShipmentResponse;
};

const RecipientDetailsTooltip = ({
  shipment,
}: RecipientDetailsTooltipProps) => {
  const [open, setOpen] = useState(false);
  const [text, setText] = useState("more...");

  const handleTooltipClose = () => {
    setOpen(false);
    setText("more...");
  };

  const handleTooltipOpen = () => {
    setOpen(!open);
    setText(open ? "more..." : "less...");
  };

  return (
    <>
      <div>Name: {shipment.recipientName}</div>
      <div>Company: {shipment.recipientCompany}</div>
      <div>Phone: {shipment.recipientPhone}</div>

      <ClickAwayListener onClickAway={handleTooltipClose}>
        <div>
          <BootstrapTooltip
            open={open}
            PopperProps={{
              disablePortal: false,
            }}
            title={
              <ul style={{ padding: "inherit", listStyleType: "none" }}>
                <li>Name:- {shipment.recipientName}</li>
                <li>Company:- {shipment.recipientCompany}</li>
                <li>Phone:- {shipment.recipientPhone}</li>
                <li>Address Type:- {shipment.recipientAddressType}</li>
                <li>Address Line 1:- {shipment.recipientAddressLine1}</li>
                <li>Address Line 2:- {shipment.recipientAddressLine2}</li>
                <li>City:- {shipment.recipientCity}</li>
                <li>State:- {shipment.recipientState}</li>
                <li>Zip:- {shipment.recipientZip}</li>
              </ul>
            }
          >
            <Button
              sx={{
                textTransform: "lowercase",
                padding: "8px",
                lineHeight: "0px",
                color: "blue",
              }}
              disableElevation={true}
              disableRipple={true}
              size="large"
              onMouseOver={() => {
                handleTooltipOpen();
              }}
              onMouseLeave={() => handleTooltipClose()}
            >
              {text}
            </Button>
          </BootstrapTooltip>
        </div>
      </ClickAwayListener>
    </>
  );
};

export default RecipientDetailsTooltip;
